import PlayStore from '../../assets/images/google-play-badge.png';
import AppStore from '../../assets/images/app-store-badge.png';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';
import useAnalyticsEventTracker from '../../hooks/use-analytics';

export const AppNotificationBar = () => {
    const gaEventTracker = useAnalyticsEventTracker('App Notification');
    const [visibleClass, setVisibleClass] = useState('hidden');
    const location = useLocation();
    const localUser = localStorage.getItem('user');
    // console.log(location.pathname);
    useEffect(() => {
        if( location.pathname === '/' ) {
            setTimeout(() => {
              setVisibleClass('');
            }, 300,);
        }
    }, [location.pathname])

    if( location.pathname !== '/' ) return null;
    
    let clickInfo = `Non-logged in click: ${Date.now()}`;
    if( localUser != null ) {
        let parsedUser = JSON.parse(localUser);
        clickInfo = `Logged in user: ${parsedUser.user.id}`;
    }

    return (
        <div className={`app-notification ${visibleClass}`}>
            <p>Continue your learning journey with the golingo app!</p>
            <a href="https://play.google.com/store/apps/details?id=uk.co.golingo" target="_blank" rel="noreferrer" onClick={ () => {
                gaEventTracker('Play Store Click', `${clickInfo}`);
                console.log(clickInfo);
            }}>
                <img src={PlayStore} alt="Google Play Store"/>
            </a>
            <a href="https://apps.apple.com/gb/app/golingo/id6444703329" target="_blank" rel="noreferrer" onClick={ () => {
                gaEventTracker('App Store Click', `${clickInfo}`);
                console.log(clickInfo);
            }}>
            <img src={AppStore} alt="App Store"/>
            </a>
            <div className='button-container'>
            <span onClick={() => {
                setVisibleClass('hidden');
            }}>Dismiss</span>
            </div>
        </div>
    );
}